import { render, staticRenderFns } from "./EmployerSettings.vue?vue&type=template&id=c95b9ff2&scoped=true"
import script from "./EmployerSettings.vue?vue&type=script&lang=ts"
export * from "./EmployerSettings.vue?vue&type=script&lang=ts"
import style0 from "./EmployerSettings.vue?vue&type=style&index=0&id=c95b9ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95b9ff2",
  null
  
)

export default component.exports